var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "product-availability-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "uk-modal-body"
  }, [(_vm.editableProvider) ? _c('radio-group-input', {
    attrs: {
      "collection": _vm.availableProviders,
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.provider,
      "inline": false,
      "label": _vm.$t('fields.provider')
    },
    model: {
      value: (_vm.fields.values.provider),
      callback: function($$v) {
        _vm.fields.values.provider = $$v
      },
      expression: "fields.values.provider"
    }
  }) : _c('readonly-form-field', {
    attrs: {
      "label": _vm.$t('fields.provider')
    }
  }, [_c('provider-name', {
    attrs: {
      "name": _vm.fields.values.provider
    }
  })], 1), _vm._v(" "), _c('text-input', {
    staticClass: "uk-width-1-4",
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.stock,
      "label": _vm.$t('fields.stock'),
      "min": 0,
      "type": "number"
    },
    model: {
      value: (_vm.fields.values.stock),
      callback: function($$v) {
        _vm.fields.values.stock = _vm._n($$v)
      },
      expression: "fields.values.stock"
    }
  }), _vm._v(" "), _c('delivery-lead-time-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.deliveryLeadTime,
      "label": _vm.$t('fields.deliveryLeadTime'),
      "type": "text"
    },
    model: {
      value: (_vm.fields.values.deliveryLeadTime),
      callback: function($$v) {
        _vm.fields.values.deliveryLeadTime = $$v
      },
      expression: "fields.values.deliveryLeadTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer uk-text-right"
  }, [_c('submit-button', {
    attrs: {
      "disabled": _vm.submitDisabled,
      "type": "primary"
    }
  }), _vm._v(" "), _c('common-button', {
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.cancel')))])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10adf0ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductAvailabilityForm.vue
// module id = 1860
// module chunks = 0